import type { VoidFunctionComponent } from 'react';

import { icons, IconText } from '../../../generic/Icon';
import Link, { DocsLink } from '../../../generic/Link';
import Section from '../../../shared/settings/SettingsPageSection';

import styles from './ProjectUpdateHooks.module.less';

/**
 * ProjectUpdateHookSettingsProvidedBuildMessage is a static message that
 * is displayed when the project is a provided build, because provided builds
 * are expected to receive updates from CI tasks via fossa-cli.
 */
const ProjectUpdateHookSettingsProvidedBuildMessage: VoidFunctionComponent = () => (
  <div className={styles.message}>
    <div className={styles.messageHeading}>
      <Section.Heading>
        <IconText
          icon={icons.questionCircle}
          text="Check your CI/CD tasks"
        />
      </Section.Heading>
    </div>
    <p className={styles.messageParagraph}>
      This project is using <DocsLink to="configuring-build-method">Provided Builds</DocsLink>, meaning it expects to receive updates from your CI tasks via <Link to="https://github.com/fossas/fossa-cli" openInNewTab>fossa-cli</Link>.
    </p>
    <p className={styles.messageParagraph}>
      In this case, updates are not managed by FOSSA or any third party service (i.e. webhooks).
      {' '}
      Instead, they are driven by how often your CI runs and successfully uploads a dependency report to FOSSA.
    </p>
    <p className={styles.messageParagraph}>
      If you need help integrating FOSSA into your CI, see <DocsLink to="provided-builds">our documentation</DocsLink>.
    </p>
  </div>
);

export default ProjectUpdateHookSettingsProvidedBuildMessage;
